// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2BmZu","colMin":"styles_colMin__9E8kq"};